<template>
  <div class="d-flex flex-wrap flex-column flex-sm-row justify-content-between">
    <div>
      <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
        All Campaigns
      </div>
      <div class="d-flex align-items-center w-100 cursor-pointer">
        <BackRoute />
      </div>
    </div>
    <div class="d-flex flex-column flex-sm-row mt-2 my-1 link">
      <router-link class="" to="/tenant/pledge/makepledge">
        <el-button
          :color="primarycolor"
          class="header-btn w-100 mt-3 mt-sm-0"
          round
        >
          Create new Campaign
        </el-button></router-link
      >
    </div>
  </div>
  <div class="container-fuild mt-5 px-0">
    <TopPerformanceCampg />
  </div>
  <div class="container-fluid mt-5 px-0">
    <TableNoExport2
      :data="filteredCampaign"
      :headers="campaignHeadaer"
      :textHead="textHead"
      @showfilter="handleFilter"
      @update:searchText="handleSearchTextUpdate"
      :checkMultipleItem="false"
      :filterItem="true"
      @checkedrow="handleSelectionChange"
    >
      <template v-slot:name="{ item }">
        <div class="c-pointer fw-400 cursor-pointer s-14" @click="viewInfo">
          {{ item.name }}
        </div>
      </template>

      <template v-slot:dateStarted="{ item }">
        <div class="c-pointer fw-400 s-14">
          {{ item.dateStarted }}
        </div>
      </template>
      <template v-slot:targetAmount="{ item }">
        <div class="c-pointer fw-400 s-14">
          N{{ item.targetAmount.toLocaleString() || "" }}
        </div>
      </template>
      <template v-slot:reached="{ item }">
        <div class="c-pointer fw-400 s-14" style="color: #1c6c04">
          N{{ item.reached.toLocaleString() || "" }}
        </div>
      </template>
      <template v-slot:toComplete="{ item }">
        <div class="c-pointer fw-400 s-14" style="color: #df6005">
          N{{ item.toComplete.toLocaleString() || "" }}
        </div>
      </template>

      <template v-slot:status="{ item }">
        <div class="c-pointer fw-400 s-14">
          {{ item.status }}
        </div>
      </template>
      <template v-slot:action="{ item }">
        <el-dropdown trigger="click">
          <el-icon><MoreFilled /></el-icon>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <div class="text-color" @click="deleteCampaign(item.id, index)">
                  Delete
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </TableNoExport2>
  </div>
</template>
<script setup>
import { ref, computed, inject } from "vue";
import TableNoExport2 from "../../../components/table/TableNoExport2.vue";
import TopPerformanceCampg from "./components/TopPerformanceCampg.vue";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import router from "../../../router";

const primarycolor = inject("primarycolor");
const navigatorLang = ref(navigator.language);
const searchText = ref("");
const textHead = ref("All Campaigns");
const showFilter = ref(false);
const handleFilter = (newValue) => {
  showFilter.value = newValue;
};
const campaignHeadaer = ref([
  { name: "CAMPAIGN NAME", value: "name" },
  { name: "DATE STARTED", value: "dateStarted" },
  { name: "TARGET", value: "targetAmount" },
  { name: "REACHED", value: "reached" },
  { name: "TO COMPLETE", value: "toComplete" },
  { name: "STATUS", value: "status" },
]);
const campaigns = ref([
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "Active",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "InActive",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "Active",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "InActive",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "Active",
  },
  {
    name: "Kids Health Care Mission",
    dateStarted: "May 10, 2024",
    targetAmount: 5000,
    reached: 2000,
    toComplete: 3000,
    status: "InActive",
  },
]);
const viewInfo = () => {
  router.push("/tenant/campaign/campaign-info");
};
const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};
const filteredCampaign = computed(() => {
  if (!searchText.value) return campaigns.value;
  return campaigns.value.filter((d) =>
    Object.values(d).some((val) =>
      String(val).toLowerCase().includes(searchText.value.toLowerCase())
    )
  );
});
</script>
<style scoped>
.card-summary {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}
.card {
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
}
.card-title {
  font-size: 25px !important;
  margin: 0;
  color: #000000;
}
.card-text {
  margin: 0;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #111111 !important;
}
.chart-container {
  height: 100%;
}
</style>
